import { Get, Post } from "./common";

export default class ReviewService {
  static getForBuyer = async (token: string) =>
    await Get({ path: "reviews/buyer", token });

  static getForAd = async (token: string, adId: string) =>
    await Get({ path: `reviews/ad/${adId}`, token });

  static submitSellerReview = async (token: string, data: any) =>
    await Post({ path: "reviews/seller", token, body: data });

  static submitPlatformReview = async (token: string, data: any) =>
    await Post({ path: "reviews/platform", token, body: data });

  static getSellerPublicReviews = async (sellerId: string, page = 0, limit = 10) =>
    await Get({
      path: `reviews/seller/${sellerId}/public?page=${page}&limit=${limit}`,
    });

  static getSellerAggregate = async (sellerId: string) =>
    await Get({ path: `reviews/seller/${sellerId}/aggregate` });

  static getMyReceivedReviews = async (token: string, page = 0, limit = 10) =>
    await Get({
      path: `reviews/seller/mine?page=${page}&limit=${limit}`,
      token,
    });

  static submitSellerResponse = async (
    token: string,
    reviewId: string,
    text: string
  ) =>
    await Post({
      path: `reviews/seller/${reviewId}/response`,
      token,
      body: { text },
    });
}
